import React from "react"

export default function ProblemHistoryReactangle(props: any) {
  return (
    <svg width="14" height="103" viewBox="0 0 14 103" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H14V88.1442L0 103V0Z" fill="#F8C33C" />
    </svg>
  )
}
